import {BlockSelector, ESD_BLOCK_SPACER} from '../../constants/BlockName';
import {ImmutableHtmlNode} from '../../modifications/ImmutableNode';
import {BuiltInControl} from '../BuiltInControl';

export abstract class SpacerBuildInControl extends BuiltInControl {
  public getTargetNodes(root: ImmutableHtmlNode): ImmutableHtmlNode[] {
    const spacers = root.querySelectorAll(BlockSelector.SPACER);
    const spacer = root.asElement().hasClass(ESD_BLOCK_SPACER) ? [root] : [];
    return spacers.length ? spacers : spacer;
  };
}
